import React from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../utils/auth";

function Play() {
  const navigate = useNavigate();

  const allGames = [
 { id: 1, title: "Katana Fruits", image: "/assets/gamescard/fruit-ninja.png", link: "http://ghanagameium.com/katana-fruits/" },
  { id: 2, title: "Water Craft", image: "/assets/gamescard/watercraft.png", link: "http://ghanagameium.com/watercraft-rush/" },
  { id: 3, title: "Penalty kicks", image: "/assets/gamescard/penaltykicks.png", link: "http://ghanagameium.com/penalty-kicks/" },
  { id: 4, title: "Duck Shooter", image: "/assets/gamescard/duck-shooter.png", link: "http://ghanagameium.com/duck-shooter/" },
  { id: 5, title: "Ultimate Swish", image: "/assets/gamescard/ultimate-swish.png", link: "http://ghanagameium.com/ultimate-swish/" },
  { id: 6, title: "Marble Blast", image: "/assets/gamescard/marbleblast.png", link: "http://ghanagameium.com/marbleblast/" },

    {id: 7,
    title: "Word Puzzle",
    image: "/assets/gamescard/word-puzzle.png",
    link: "http://ghanagameium.com/word-puzzle/",
  },
  { id: 8, title: "Different Emoji", image: "/assets/gamescard/different-emoji.png",link: "http://ghanagameium.com/emoji-difference/"},
  { id: 9, title: "Fruit Skill", image: "/assets/gamescard/stick-fruit.png",link: "http://ghanagameium.com/fruit-skill/" },
  { id: 10, title: "Lucky Wheels", image: "/assets/gamescard/lucky-wheel.png",link: "http://ghanagameium.com/luckywheels/"},
  { id: 11, title: "Urban Crosser", image: "/assets/gamescard/urban-crosser.png",link: "http://ghanagameium.com/urban-crosser/" },
  { id: 12, title: "Guess The Quiz", image: "/assets/gamescard/guessquiz.png",link: "http://ghanagameium.com/engaging-emoji/" },

   {
    id: 13,
    title: "Gear Madness",
    image: "/assets/gamescard/gear-madness.png",
    link: "http://ghanagameium.com/gear-madness/",
  },
  { id: 14, title: "Traffic Racer", image: "/assets/gamescard/traffic-racer.png", link: "http://ghanagameium.com/traffic-racer/", },
  { id: 15, title: "Aero Rush", image: "/assets/gamescard/aero-rush.png" },
  { id: 16, title: "Formula Rush", image: "/assets/gamescard/formula-rush.png",link: "http://ghanagameium.com/formula-racing/",},
  { id: 17, title: "Roadmash Car", image: "/assets/gamescard/roadmash22.png",link: "http://ghanagameium.com/gameio-roadmash/" },
  { id: 18, title: "Fastlanego", image: "/assets/gamescard/fast-lane.png" },

  {
    id: 19,
    title: "puzzle master",
    image: "/assets/gamescard/puzzle-master.png",
    link: "http://ghanagameium.com/jigsaw-puzzle/",
  },
  { id: 20, title: "Genius", image: "/assets/gamescard/genius.png", link: "http://ghanagameium.com/genius/", },
  { id: 21, title: "Sudoku", image: "/assets/gamescard/sudoku.png", link: "http://ghanagameium.com/sudoku/", },
  { id: 22, title: "Slider Puzzle", image: "/assets/gamescard/sliderpuzzle.png", link: "http://ghanagameium.com/slider-puzzle/", },
  { id: 23, title: "Spelling Challenge", image: "/assets/gamescard/spellingchllange.png", link: "http://ghanagameium.com/spelling-challenge/", },
  { id: 24, title: "3D Maze", image: "/assets/gamescard/3dmaze.png", link: "http://ghanagameium.com/3dmaze/",},
  {
    id: 25,
    title: "Neon Pong",
    image: "/assets/gamescard/neonpong.png",
    link: "http://ghanagameium.com/ai-puzzle/",
  },
  { id: 26, title: "Connect Four Classic", image: "/assets/gamescard/connectfour.png", link: "http://ghanagameium.com/connect-four-classic/", },
  { id: 27, title: "Archery Master", image: "/assets/gamescard/shooting.png", link: "http://ghanagameium.com/shooting-game/", },
  { id: 28, title: "Water Sort", image: "/assets/gamescard/watersort.png", link: "http://ghanagameium.com/water-sort-puzzle/", },
  { id: 29, title: "Color Spinner", image: "/assets/gamescard/color-spinner.png", link: "http://ghanagameium.com/color-spinner/", },
  { id: 30, title: "Juicy Puzzle", image: "/assets/gamescard/juicy-puzzle.png", link: "http://ghanagameium.com/juicy-puzzle/",},
  { id: 31, title: "tetris-evolution", image: "/assets/gamescard/tetris-evolution.png", link: "http://ghanagameium.com/tetris-evolution/", },
  { id: 32, title: "Word Puzzle", image: "/assets/gamescard/word-puzzle.png", link: "http://ghanagameium.com/word-puzzle", },
  { id: 33, title: "Guess The Quezz", image: "/assets/gamescard/guessquiz.png", link: "http://ghanagameium.com/engaging-emoji/", },
];

  // ✅ SAME CLICK HANDLER AS TRENDING
const handleGameClick = async (game) => {
  const currentUser = await getCurrentUser();

  // 🔥 fallback check
  const isSubscribed = currentUser.success && currentUser.isSubscribed;

  if (!isSubscribed) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("isSubscribed");
    localStorage.removeItem("isLoggedIn");
    navigate("/signin");
    return;
  }

  // 🔥 ensure storage set
  localStorage.setItem("isSubscribed", "true");
  localStorage.setItem("isLoggedIn", "true");

  if (game.link) {
    window.location.href = game.link;
  } else {
    navigate("/games");
  }
};

  return (
    <div className="bg-[#181820] min-h-screen">

      {/* ================= BANNER ================= */}
      <section className="relative w-full h-[360px] md:h-[420px] bg-[#0b0720] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}
        />
   {/* 🔴 RED COLOR OVERLAY */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#ff003c]/40 to-[#6a00ff]/40 mix-blend-overlay"></div>

        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center justify-between">
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-3">
              Play as you go
            </h1>
            <p className="text-gray-300 text-sm">
              Home <span className="mx-2">›</span> Play
            </p>
          </div>

          <div className="relative hidden md:flex items-center justify-center w-[620px] h-full">
            <img
              src="/assets/play-shape-1.webp"
              alt="planet"
              className="absolute w-[150px] opacity-90 right-8 top-16"
              style={{ animation: "rotate360 1s linear infinite" }}
            />

            <img
              src="/assets/banner-play-go-illus.webp"
              alt="trophy"
              className="relative w-[400px] z-10 me-4 mt-20"
              style={{ animation: "spinSlow 18s linear infinite" }}
            />
          </div>
        </div>
      </section>

      {/* ================= GAMES LIST ================= */}
      <div className="pt-14 pb-40">
        <div className="container mx-auto px-4 sm:px-6 lg:px-10">

          <h2 className="text-center text-3xl font-bold text-white mb-14">
           <span className="text-[#ff003c] font-semibold">Games</span>
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6 lg:gap-8">
            {allGames.map((res) => (
              <div
                key={res.id}
                className="group flex flex-col h-full cursor-pointer"
                onClick={() => handleGameClick(res)}
              >
                <div className="overflow-hidden rounded-2xl border-2 border-[#36363e] group-hover:border-yellow-500 transition-all duration-300 h-[180px]">
                  <img
                    src={res.image}
                    alt={res.title}
                    className="w-full h-full object-fill group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <h3 className="mt-4 text-center text-white text-lg font-semibold flex-grow flex items-center justify-center">
                  {res.title}
                </h3>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
}

export default Play;
